import { Roles, Subjects } from "settings/permissions";

export const REDIRECT_TO_QUERY_OPTIMIZATION_ROI = "/planners/query-optimization-roi";
export const REDIRECT_TO_SCHEMA_CHANGE_COST = "/planners/schema-change-cost";
export const REDIRECT_TO_MIGRATION = "/planners/migration";
export const REDIRECT_TO_STORAGE_CAPACITY = "/planners/storage_capacity";

export const REDIRECT_OPTIMIZATION_PERFORMANCE = "/planners";

export const plannerPages = {
  id: "Planners",
  label: (
    <span>
      Planners
      {/* <span
        style={{
          borderRadius: "10px",
          backgroundColor: "#f3f5fb",
          fontSize: "var(--fs10)",
          padding: "2px 6px",
          marginLeft: "10px",
          color: "navy",
        }}>
        Calculators
      </span> */}
    </span>
  ),
  icon: "metricsApp",
  isSingle: true,
  items: [
    // {
    //   label: "Migration",
    //   path: "/planner/migration",
    //   requireClientSelection: true,
    //   permissions: {
    //     subject: Subjects.Calculators,
    //     role: Roles.Read,
    //   },
    //   parent: {
    //     id: "Planners",
    //     label: "Planners",
    //     icon: "metricsApp",
    //   },
    //   topNavLinks: [
    //     // {
    //     //   label: "Overview",
    //     //   path: "/planner/query-optimization",
    //     //   requireClientSelection: true,
    //     //   subItems: [
    //     //     {
    //     //       label: "Query Optimization ROI Calculator",
    //     //       path: "/planner/query-optimization/query-optimization-roi",
    //     //       requireClientSelection: true,
    //     //     },
    //     //     {
    //     //       label: "Query Optimization Impact Calculator",
    //     //       path: "/planner/query-optimization/query-optimization-impact",
    //     //       requireClientSelection: true,
    //     //     },
    //   ],
    // },
    {
      label: "Overview",
      path: "/planners",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Calculators,
        role: Roles.Read,
      },
      parent: {
        id: "Planners",
        label: "Planners",
        icon: "metricsApp",
      },
      topNavLinks: [
        {
          label: "Overview",
          path: "/planners",
          requireClientSelection: true,
          subItems: [
            {
              label: "Query ROI Planner",
              path: "/planners/query-optimization-roi",
              requireClientSelection: true,
            },
            {
              label: "Schema Change Cost Planner",
              path: "/planners/schema-change-cost",
              requireClientSelection: true,
            },
            {
              label: "Migration Recommendations Planner",
              path: "/planners/migration",
              requireClientSelection: true,
            },
            {
              label: "Storage Capacity Planner",
              path: "/planners/storage_capacity",
              requireClientSelection: true,
            },
          ],
        },
      ],
    },

    // {
    //   label: "Infrastructure",
    //   path: "/planner/infrastructure",
    //   requireClientSelection: true,
    //   permissions: {
    //     subject: Subjects.Calculators,
    //     role: Roles.Read,
    //   },
    //   parent: {
    //     id: "Planners",
    //     label: "Planners",
    //     icon: "diff",
    //   },
    //   topNavLinks: [
    //     // {
    //     //   label: "Overview",
    //     //   path: "/planner/query-optimization",
    //     //   requireClientSelection: true,
    //     //   subItems: [
    //     //     {
    //     //       label: "Query Optimization ROI Calculator",
    //     //       path: "/planner/query-optimization/query-optimization-roi",
    //     //       requireClientSelection: true,
    //     //     },
    //     //     {
    //     //       label: "Query Optimization Impact Calculator",
    //     //       path: "/planner/query-optimization/query-optimization-impact",
    //     //       requireClientSelection: true,
    //     //     },
    //   ],
    // },

    // {
    //   label: "Financial",
    //   path: "/planner/financial",
    //   requireClientSelection: true,
    //   permissions: {
    //     subject: Subjects.Calculators,
    //     role: Roles.Read,
    //   },
    //   parent: {
    //     id: "Planners",
    //     label: "Planners",
    //     icon: "diff",
    //   },
    //   topNavLinks: [
    //     // {
    //     //   label: "Overview",
    //     //   path: "/planner/query-optimization",
    //     //   requireClientSelection: true,
    //     //   subItems: [
    //     //     {
    //     //       label: "Query Optimization ROI Calculator",
    //     //       path: "/planner/query-optimization/query-optimization-roi",
    //     //       requireClientSelection: true,
    //     //     },
    //     //     {
    //     //       label: "Query Optimization Impact Calculator",
    //     //       path: "/planner/query-optimization/query-optimization-impact",
    //     //       requireClientSelection: true,
    //     //     },
    //   ],
    // },
  ],
};
